import React, { Component } from 'react';

class ChatContainer extends Component {
  render() {
    return <div />;
  }
}

export default ChatContainer;



// WEBPACK FOOTER //
// ./src/containers/Utilities/ChatTester.js